import { HStack, Image, VStack } from '@chakra-ui/react';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type HeaderProps = {
  image?: string;
  title: string;
  breadCrumb?: React.ReactNode;
};

export const Header: React.FC<HeaderProps> = ({ breadCrumb, image, title }) => {
  return (
    <VStack
      borderBottomColor="blackAlpha.100"
      borderBottomStyle="solid"
      borderBottomWidth="1px"
      alignItems={['flex-start']}
      gap="20px"
      paddingBottom={['12px', '12px', '12px', '36px']}
      width="full">
      {breadCrumb && breadCrumb}
      <HStack gap="20px">
        {image && <Image src={image} width={'60px'} height={'50px'} borderRadius="5px" />}
        {/* <Image image="cash-flow-icon" width={['24px', '24px', '24px', '48px']} /> */}
        <TextBlock
          fontSize={['24px', '24px', '24px', '48px']}
          lineHeight={['32px', '32px', '32px', '48px']}
          weight="bold">
          {title}
        </TextBlock>
      </HStack>
    </VStack>
  );
};
